export function dummyRequest({ file, onSuccess }: any) {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
}
